"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const HRStyle = styled_components_1.default.hr `
  background: ${({ theme }) => theme.palette.border.default};
  height: 1px;
`;
/**
 * Horizontal Rule <hr />
 */
const HR = props => {
    return react_1.default.createElement(HRStyle, Object.assign({}, props));
};
exports.default = HR;
//# sourceMappingURL=HR.js.map